<template>
  <div>
    <skeleton :loading="isOptionsLoading" width="100%"></skeleton>
    <skeleton
      :loading="isOptionsLoading"
      width="100%"
      marginBottom="6px"
    ></skeleton>
    <skeleton
      :loading="isOptionsLoading"
      width="100%"
      height="50px"
      marginBottom="6px"
    ></skeleton>
    <skeleton :loading="isOptionsLoading" width="100%"></skeleton>
    <skeleton
      :loading="isOptionsLoading"
      width="100%"
      marginBottom="6px"
    ></skeleton>
    <skeleton :loading="isOptionsLoading" width="100%" height="50px"></skeleton>
    <skeleton
      :loading="isOptionsLoading"
      width="100%"
      marginBottom="6px"
    ></skeleton>
    <skeleton :loading="isOptionsLoading" width="100%" height="50px"></skeleton>
    <skeleton
      :loading="isOptionsLoading"
      width="100%"
      marginBottom="6px"
    ></skeleton>
    <skeleton :loading="isOptionsLoading" width="100%" height="50px"></skeleton>
    <skeleton
      :loading="isOptionsLoading"
      width="100%"
      height="150px"
    ></skeleton>
    <skeleton :loading="isOptionsLoading" width="100%" height="40px"></skeleton>
    <skeleton :loading="isOptionsLoading" width="100%" height="50px"></skeleton>
    <skeleton :loading="isOptionsLoading" width="100%" height="3px"></skeleton>
    <skeleton
      :loading="isOptionsLoading"
      width="100%"
      height="40px"
      marginBottom="0px"
    ></skeleton>
  </div>
</template>

<script>
import Skeleton from "../shared/ProductSkeleton";
import { mapGetters } from "vuex";

export default {
  components: {
    Skeleton
  },
  computed: {
    ...mapGetters("enhancedproduct", ["isOptionsLoading"])
  }
};
</script>

<style lang="scss" scoped></style>
